__webpack_public_path__ = window.__webpack_public_path__;

import '../styles/radiant.scss';
import smoothscroll from 'smoothscroll-polyfill';
import Theme from './Theme';

smoothscroll.polyfill();

let theme = new Theme();
theme.mountComponents();

document.addEventListener('shopify:section:unload', (e) => {
  theme.unmountComponents(e.target);
});

document.addEventListener('shopify:section:load', (e) => {
  theme.mountComponents(e.target);
  theme._ctx.emit('radiant--lazy-load-update');
});
 